
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'

@Component({
  components: {
    Title,
    LazyImg
  }
})
export default class Experience extends Vue {
  @Prop() dataSource: {
    count: number
    level: number
    progress: number
    sumexperience: number
  }

  get experienceBackground() {
    switch (this.dataSource.level) {
      case 0:
        return '#E7E7DD'
      case 1:
        return '#EBE0D0'
      case 2:
        return '#EBD9BE'
      case 3:
        return '#E7D4BD'
      case 4:
        return '#E7D2C4'
      case 5:
        return '#E7CEC0'
      case 6:
        return '#E7CCBD'
      case 7:
        return '#E6C8C5'
      case 8:
        return '#E7C7C4'
      case 9:
        return '#E7C4C3'
      case 10:
        return ''
    }
  }

  experienceBtn() {
    this.$router.push({ name: 'experience' })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
